export default ({ store }) => {
  if (process.client) {
    document.addEventListener("click", (event) => {
      const target = event.target.closest("[data-asset-view]");
      
      if (target) {
        const url = target.getAttribute("data-asset-view");
        const type = target.getAttribute("data-asset-view-type") || "image";
        
        if (url) {
          const file = {
            url,
            media_type: type === "video" ? "video" : "image",
            alt: "Asset",
          };
          
          store.dispatch("general/setImageViewer", {
            isOpen: true,
            file,
          });
        }
      }
    });
  }
}; 